import { State } from '@meraki-internal/state';

export interface IAddMedicationHandlers {
    onTakePhoto: () => void;
    onType: () => void;
}

interface IAddMedicationLauncherState {
    isChoiceOpen: boolean;
}

/**
 * Routes the single mobile "Add Medication" entry point to either the photo-capture flow or
 * the manual editor, once the user picks in AddMedicationChoiceSheet. Deliberately far simpler
 * than AddCareRecipientLauncher (no caremap creation/rollback/wizard) -- medications only need
 * photo-vs-type routing on top of an existing patient.
 */
export class AddMedicationLauncher extends State<IAddMedicationLauncherState> {
    private handlers?: IAddMedicationHandlers;

    constructor() {
        super({ isChoiceOpen: false });
    }

    // Registers the handlers for the next choice without opening the sheet -- the caller opens
    // it separately via openChoice() once it has finished wiring both handlers.
    open = (handlers: IAddMedicationHandlers) => {
        this.handlers = handlers;
    };

    openChoice = () => {
        this.setState({ isChoiceOpen: true });
    };

    cancel = () => {
        this.setState({ isChoiceOpen: false });
    };

    chooseTakePhoto = () => {
        // deliberately do NOT close the sheet here -- it stays open behind the native photo picker
        // until a file is actually received (or the picker is cancelled), so tapping "Take a Photo"
        // doesn't make the sheet vanish before the user has picked anything. The caller closes it
        // via cancel() on file-received / picker-cancel.
        this.handlers?.onTakePhoto();
    };

    chooseType = () => {
        this.setState({ isChoiceOpen: false });
        this.handlers?.onType();
    };
}
